
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"vuesax/bulk/call-calling","xmlns":"http://www.w3.org/2000/svg","width":"13","height":"13","viewBox":"0 0 13 13"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#f29030"}},[_c('path',{attrs:{"d":"M9.544 5.823a.417.417 0 01-.417-.417 1.885 1.885 0 00-.536-.98 1.512 1.512 0 00-1-.558.418.418 0 11.003-.835 2.3 2.3 0 011.609.818A2.556 2.556 0 019.967 5.4a.423.423 0 01-.423.423z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M11.499 5.823a.417.417 0 01-.417-.418 3.487 3.487 0 00-3.483-3.482.42.42 0 01-.005-.84 4.328 4.328 0 014.322 4.322.421.421 0 01-.417.418z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M6.383 7.697L4.615 9.468q-.292-.26-.569-.536a15.391 15.391 0 01-1.511-1.771 9.657 9.657 0 01-1.062-1.848 4.562 4.562 0 01-.39-1.771 2.8 2.8 0 01.195-1.045 2.493 2.493 0 01.623-.9 1.587 1.587 0 011.127-.514 1.018 1.018 0 01.439.1.883.883 0 01.363.3l1.253 1.772a1.854 1.854 0 01.217.379.856.856 0 01.076.33.735.735 0 01-.114.385 1.842 1.842 0 01-.3.385l-.412.428a.29.29 0 00-.087.221.492.492 0 00.02.12c.016.043.032.076.043.108a4.5 4.5 0 00.5.693c.244.282.5.569.785.856.196.19.385.374.572.537z","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M11.9 9.929a1.376 1.376 0 01-.081.46 1.323 1.323 0 01-.054.13 2.235 2.235 0 01-.368.553 2.442 2.442 0 01-.888.639c-.005 0-.011.005-.016.005a2.736 2.736 0 01-1.04.2 4.514 4.514 0 01-1.766-.4 9.514 9.514 0 01-1.864-1.067c-.211-.157-.423-.314-.623-.482l1.771-1.772a3.043 3.043 0 00.4.26c.027.011.06.027.1.043a.374.374 0 00.129.022.3.3 0 00.227-.092l.412-.406a1.662 1.662 0 01.39-.3.721.721 0 01.384-.117.864.864 0 01.33.07 2.1 2.1 0 01.379.211l1.794 1.274a.822.822 0 01.3.347 1.111 1.111 0 01.084.422z"}})])])
          )
        }
      }
    